/**
 * remove key from
 */
export const remove = (key) => {
  document.cookie = `${key}=; Max-Age=-99999999; path=/;`
}

export default remove
